module.exports = __webpack_public_path__ + "img/grey-info-icon.fcb08fa3.svg";